<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-08 14:16:27
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-26 19:44:30
 * @Description: 选择开票主体
-->
<template>
  <div class="column wrap">
    <!-- 企业列表 -->
    <div class="tip">
      导入文件共{{ uploadInfo.allCount }}条，匹配成功{{
        uploadInfo.successCount
      }}条,失败<span class="failCount">{{ uploadInfo.failCount }}</span
      >条
      <a href="javascript:" @click="showError" v-if="uploadInfo.failCount">查看失败原因</a>
    </div>
    <Table ref="table" class="table-wrap flex-1" :tableConfig="tableConfig">
    </Table>
    <div class="btns">
      <el-button size="small" @click="cancel">取消导入</el-button>
      <el-button size="small" @click="confirm" class="mgl" type="primary"
        >确定提交</el-button
      >
    </div>
  </div>
</template>

<script>
import Table from '@/components/table/index.vue'
import { tableToExcel } from '@/utils/tableToExcel'
export default {
  components: {
    Table
  },
  props: {
    uploadInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      tableConfig: {
        autoSearch: false, // 是否需要默认查询
        needPagination: true, // 是否需要分页
        frontEndPaging: true, // 前端分页
        fluidHeight: true, // 流体高度
        showOrdinal: false, // 是否显示序号,
        hideLabel: true, // 搜索隐藏label
        params: [
          {
            prop: 'orderCode',
            label: '所属单号',
            placeholder: '所属单号',
            width: '160px'
          },
          {
            prop: 'goodsCode',
            label: '商品编号',
            placeholder: '商品编号'
          },
          {
            prop: 'goodsName',
            label: '商品名称',
            placeholder: '商品名称模糊'
          },
          {
            prop: 'goodsModel',
            label: '型号',
            hideInSearch: true
          },
          {
            prop: 'transactionPrice',
            label: '含税单价',
            hideInSearch: true
          },
          {
            prop: 'invoiceNum',
            label: '本次开票数量',
            hideInSearch: true
          },
          {
            prop: 'invoiceAmount',
            label: '本次开票金额',
            hideInSearch: true
          }
        ]
      }
    }
  },
  mounted () {
    this.$refs.table.setFrontPage(this.uploadInfo.successItemVoList)
  },
  methods: {
    // 查看失败原因
    showError () {
      const data = [...this.uploadInfo.failItemVoList]
      if (data.length === 0) {
        this.$message.warning('没有要导出的内容')
        return
      }
      data.forEach((v) => {
        v.goodsNumTotal = `${v.hasInvoiceNum}/${v.goodsNum}`
        v.taxRateStr = `${v.taxRate * 100}%`
      })
      const titles = {
        serialNumber: '序号',
        orderCode: '订单编号',
        goodsCode: '商品编码',
        invoiceNum: '开票数量',
        errorInfo: '失败原因'
      }
      tableToExcel({ data, titles, fileName: '失败原因导出.xls' })
    },
    // 关闭
    cancel () {
      this.$emit('cancel')
    },
    //  确认选择信息
    confirm () {
      if (this.uploadInfo.successItemVoList.length === 0) {
        this.$message.warning('没有匹配成功的明细')
        return
      }
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  height: 500px;
}
.btns {
  padding: 30px 0 0;
  text-align: center;
  .mgl {
    margin-left: 32px;
  }
}

.tip {
  font-size: 18px;
  color: #1abc9c;
  padding-bottom: 12px;
  a {
    margin-left: 12px;
  }
  .failCount {
    color: #d9001b;
  }
}
</style>
